import { render } from "./DadminLoginList.vue?vue&type=template&id=2b358678"
import script from "./DadminLoginList.vue?vue&type=script&lang=js"
export * from "./DadminLoginList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__